import React from 'react';
import PropTypes from 'prop-types';
import { getCardClassName } from '../../utils/cardStyles';

class DealtCard extends React.Component {
  static get propTypes() {
    return {
      card: PropTypes.string.isRequired,
      gameMode: PropTypes.string.isRequired,
    };
  }

  render() {
    return (
      <div
        className={`playing-card ${getCardClassName(
          this.props.gameMode,
          this.props.card,
        )} active card-rounded scaled-big`}
      />
    );
  }
}

export default DealtCard;
